export function readJsonData<T>(element: HTMLElement | null, attr: string): T | null {
  if (!element) return null
  const raw = element.getAttribute(attr)
  if (!raw) return null
  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}
